<template>
  <div style="height:100%">
    <template v-if="showHeader">
      <v-navbar :title="title"> </v-navbar>
    </template>
    <div :class="{ 'show-header': showHeader, 'hide-header': !showHeader }">
      <keep-alive>
        <router-view
          v-if="$route.meta.keepAlive"
          class="router-view"
        ></router-view>
      </keep-alive>
      <router-view
        v-if="!$route.meta.keepAlive"
        class="router-view"
      ></router-view>
      <!-- 智能导航助手：由 web/position/showNavAssistant 接口决定是否展示 -->
      <nav-assistant v-if="enableNavAssistant"></nav-assistant>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { COMMON_TITLE } from "@/constants/title.js";
import { configWechatShare } from "@/utils/wechatShare";
import navAssistant from "@/components/navAssistant/index.vue";
import { mapGetters } from "vuex";
import { initSensor } from "@/countly.js";
export default {
  components: {
    navAssistant
  },
  data() {
    return {
      title: "",
      showHeader: window.showHeader,
    };
  },
  computed: {
    ...mapGetters(["enableNavAssistant"])
  },
  watch: {
    $route: "path",
    // 导航助手显示状态变化时，若未显示则重新查询权限
    "$store.state.app.navAssistantEnabled"(val) {
      // 仅在状态变为 false 且用户已登录时重新查询
      if (val === false && this.$store.state.global.personInfo && this.$store.state.global.personInfo.userName) {
        this.queryNavAssistantShow();
      }
    },
    // 用户信息变化时（如登录成功），初始化埋点并查询导航助手权限
    "$store.state.global.personInfo"(val) {
      if (val && val.userName) {
        // 初始化神策埋点
        initSensor(val.userName);
        // 查询导航助手权限
        if (this.$store.state.app.navAssistantEnabled === false) {
          this.queryNavAssistantShow();
        }
      }
    }
  },
  mounted() {
    this.intUrl();
    this.login();
    this.checkLogin(); // 获取已登录用户信息
    this.querySeason();
    this.queryNavAssistantShow();
    // 如果用户已登录，初始化埋点
    const personInfo = this.$store.state.global.personInfo;
    if (personInfo && personInfo.userName) {
      console.log("[App] 用户已登录，初始化埋点:", personInfo.userName);
      initSensor(personInfo.userName);
    }
    let searchObj = window.location.search.replace("?", "");
    console.log(location, searchObj, qs.parse(searchObj));
    // 默认微信分享配置
    configWechatShare({
      title: "顺丰校园招聘",
      desc: "为应届大学毕业生及在校生提供最新校园招聘信息",
      link: window.location.href,
      imgUrl: require("../src/assets/header/SF-logo.png") // 分享图标
    });
  },
  methods: {
    intUrl() {
      const host = window.location.host;
      const isSit = host.indexOf("sit") > 0;
      const isLocalhost =
        host.indexOf("localhost") != -1 || host.indexOf("127.0.0.1") != -1
          ? true
          : false;
      // 非sit环境且非本地环境情况下 就做https重定向
      if (isSit || isLocalhost) {
        return;
      } else {
        let url = window.location.href;
        url = url.replace("http:", "https:");
        window.location.href = url;
        return;
      }
    },
    querySeason() {
      this.$axios.get(`web/messageReleaseWeb/querySeason`).then(
        res => {
          this.$store.commit("setNoSeason", !res ? true : false);
        },
        err => {
          this.$toast.show({
            text: (err && err.msg) || "请求失败",
            type: "warn",
            time: 2000
          });
        }
      );
    },
    /**
     * 微信端拿到code后直接去登录
     */
    login() {
      ///微信跳转地址类似：http://crs.sit.sf-express.com/cr/?code=123456#/homePage
      let that = this;
      let search = window.location.search.replace("?", "");
      let searchObj = {};
      if (search != "") {
        searchObj = qs.parse(search);
      }

      let params = {},
        storeParams = {};

      //如果是从微信进来，取得到code、state、channel(识别不同的公众号)
      searchObj.code && (params.code = searchObj.code);
      searchObj.state && (params.state = searchObj.state);
      searchObj.channel && (params.channel = searchObj.channel);

      // url中loginType也要存在store里
      storeParams = JSON.parse(JSON.stringify(params));
      searchObj.loginType && (storeParams.loginType = searchObj.loginType);
      this.$store.commit("setUrlAttr", storeParams);

      params = Object.assign(params, { passLogin: 1 });

      if (params.code) {
        //如果绑定过微信调接口解锁登录状态，否则仍是未登录状态
        this.$axios.post(`web/index/prsLogin`, params, { passLogin: 1 }).then(
          res => {
            this.$nextTick(() => {
              // true: 标识已登录
              window.dispatchEvent(
                new CustomEvent("nav-assistant:send-login-state", { detail: true })
              );
            });
          },
          err => {
            if (!(err && err.msg == "未登录，请先登录")) {
              that.$toast.show({
                text: (err && err.msg) || "请求失败",
                type: "text",
                time: 1000
              });
            }
          }
        );
      }
    },
    checkLogin() {
      this.$axios.get(`web/index/webLogin`, { params: { passLogin: 1 } }).then(
        res => {
          this.$store.commit("setPersonInfo", res);
          window.localStorage.setItem("personInfo", res.userKey);
          this.$nextTick(() => {
            window.dispatchEvent(
              new CustomEvent("nav-assistant:send-login-state", { detail: { userKey: res.userKey } })
            );
          });
        },
        err => {
          that.$toast.show({
            text: (err && err.msg) || "请求失败",
            type: "text",
            time: 1000
          });
        }
      );
    },
    path() {
      if (this.$route.meta && this.$route.meta.title) {
        this.title = this.$route.meta.title;
        document.title = this.title;
      } else {
        this.title = COMMON_TITLE;
        document.title = COMMON_TITLE;
      }
    },
    // 查询导航助手是否显示（web/position/showNavAssistant）
    queryNavAssistantShow() {
      this.$axios
        .get(`web/position/showNavAssistant`)
        .then(res => {
          if (res && res.show === true) {
            this.$store.commit("setNavAssistantEnabled", true);
          } else {
            this.$store.commit("setNavAssistantEnabled", false);
          }
        })
        .catch(() => {
          this.$store.commit("setNavAssistantEnabled", false);
        });
    }
  }
};
</script>
<style scoped>
.show-header {
  height: calc(100% - 46px);
  overflow: hidden;
}
.hide-header {
  height: calc(100%);
  overflow: hidden;
}
.van-toast__icon {
  font-size: 36px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue